import Header from "../components/Header";
import "./Design/Dashboard.css";
import "./Courses/MyCourses.css";
import { useEffect, useRef, useState } from "react";
import { dashboard } from "../handler/LoginAndSingupHandler";
import courseImage from "src/Common/CourseImage";

interface Course {
    courseId: number;
    courseName: string;
    packageId: number;
    courseDescription: string;
    coursePrice: number;
}

const Courses = () => {
    const [loader, setLoader] = useState(true);
    const [activeFilter, setActiveFilter] = useState(1);

    const [packages, setPackages] = useState<Course[]>([
        {
            courseId: 0,
            courseName: "",
            packageId: 0,
            courseDescription: "",
            coursePrice: 0,
        },
    ]);

    const categories = [
        "All",
        "Basic Package",
        "Advanced Package",
        "Silver Package",
        "Gold Package",
        "Platinum Package",
    ];

    const handleFilter = (category: number) => {
        setActiveFilter(category);
    };

    const getCourses = async () => {
        try {
            const response = await dashboard(2);

            if (response.statusCode === 200) {
                setPackages(response.data.dashboard.courses);
            }
        } catch (error) {
            console.error("Error loading courses:", error);
        }

        setLoader(false);
    };

    const runValue = useRef(false);

    useEffect(() => {
        if (runValue.current === false) {
            getCourses();
            runValue.current = true;
        }
    }, []);

    const filteredCourses = packages
        .filter((data) =>
            activeFilter === 1
                ? data.packageId > 0
                : data.packageId === activeFilter - 1
        )
        .sort((a, b) => b.packageId - a.packageId);

    return (
        <>
            <Header />

            {/* =========================
                COURSES SECTION
            ========================== */}
            <section
                className="courses-page-section"
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg, #050505 0%, #111111 50%, #000000 100%)",
                    padding: "50px 20px 80px",
                    position: "relative",
                }}
            >
                {/* Background glow */}
                <div
                    style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "400px",
                        background:
                            "radial-gradient(circle at 50% 0%, rgba(255,255,255,0.08), transparent 60%)",
                        pointerEvents: "none",
                    }}
                />

                <div
                    className="container-fluid"
                    style={{
                        maxWidth: "1400px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 1,
                    }}
                >

                    {/* =========================
                        PAGE TITLE
                    ========================== */}
                    <div
                        className="text-center"
                        style={{
                            marginBottom: "35px",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-block",
                                fontSize: "13px",
                                letterSpacing: "3px",
                                textTransform: "uppercase",
                                color: "#bdbdbd",
                                marginBottom: "10px",
                                fontWeight: "600",
                            }}
                        >
                            Growniverse Learning
                        </span>

                        <h1
                            style={{
                                color: "#ffffff",
                                fontSize: "42px",
                                fontWeight: "700",
                                marginBottom: "12px",
                            }}
                        >
                            Explore Our Courses
                        </h1>

                        <p
                            style={{
                                color: "#a8a8a8",
                                maxWidth: "700px",
                                margin: "0 auto",
                                fontSize: "16px",
                                lineHeight: "1.7",
                            }}
                        >
                            Learn new skills, develop your personality and
                            build a better future with Growniverse.
                        </p>
                    </div>

                    {/* =========================
                        FILTERS
                    ========================== */}
                    <div
                        className="filters-wrapper"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: "10px",
                            marginBottom: "45px",
                            padding: "10px",
                        }}
                    >
                        {categories.map((category, index) => (
                            <button
                                key={category}
                                onClick={() => handleFilter(index + 1)}
                                style={{
                                    border:
                                        activeFilter === index + 1
                                            ? "1px solid #ffffff"
                                            : "1px solid #444444",

                                    background:
                                        activeFilter === index + 1
                                            ? "#ffffff"
                                            : "#111111",

                                    color:
                                        activeFilter === index + 1
                                            ? "#000000"
                                            : "#ffffff",

                                    padding: "11px 22px",
                                    borderRadius: "30px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    boxShadow:
                                        activeFilter === index + 1
                                            ? "0 5px 20px rgba(255,255,255,0.15)"
                                            : "none",
                                }}
                            >
                                {category}
                            </button>
                        ))}
                    </div>

                    {/* =========================
                        LOADER
                    ========================== */}
                    {loader && (
                        <div
                            style={{
                                minHeight: "300px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div className="text-center">
                                <div
                                    className="spinner-border"
                                    role="status"
                                    style={{
                                        width: "45px",
                                        height: "45px",
                                        color: "#ffffff",
                                    }}
                                ></div>

                                <p
                                    style={{
                                        color: "#aaaaaa",
                                        marginTop: "15px",
                                    }}
                                >
                                    Loading courses...
                                </p>
                            </div>
                        </div>
                    )}

                    {/* =========================
                        COURSES
                    ========================== */}
                    {!loader && filteredCourses.length === 0 && (
                        <div
                            className="text-center"
                            style={{
                                padding: "80px 20px",
                                color: "#ffffff",
                            }}
                        >
                            <i
                                className="fas fa-book-open"
                                style={{
                                    fontSize: "45px",
                                    marginBottom: "20px",
                                    color: "#777777",
                                }}
                            ></i>

                            <h3 style={{ color: "#ffffff" }}>
                                No Courses Found
                            </h3>

                            <p style={{ color: "#888888" }}>
                                There are currently no courses available in
                                this package.
                            </p>
                        </div>
                    )}

                    {!loader && filteredCourses.length > 0 && (
                        <div className="row g-4">
                            {filteredCourses.map((course) => {
                                const image =
                                    courseImage.find(
                                        (data) =>
                                            data.courseId === course.courseId
                                    )?.posterLink;

                                return (
                                    <div
                                        className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                                        key={course.courseId}
                                    >
                                        <div
                                            className="course-modern-card"
                                            style={{
                                                background: "#0d0d0d",
                                                border: "1px solid #292929",
                                                borderRadius: "16px",
                                                overflow: "hidden",
                                                height: "100%",
                                                transition:
                                                    "all 0.3s ease",
                                                boxShadow:
                                                    "0 10px 30px rgba(0,0,0,0.35)",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform =
                                                    "translateY(-6px)";
                                                e.currentTarget.style.borderColor =
                                                    "#555555";
                                                e.currentTarget.style.boxShadow =
                                                    "0 15px 40px rgba(0,0,0,0.6)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform =
                                                    "translateY(0)";
                                                e.currentTarget.style.borderColor =
                                                    "#292929";
                                                e.currentTarget.style.boxShadow =
                                                    "0 10px 30px rgba(0,0,0,0.35)";
                                            }}
                                        >

                                            {/* =========================
                                                COURSE IMAGE
                                            ========================== */}
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "240px",
                                                    overflow: "hidden",
                                                    background: "#151515",
                                                }}
                                            >
                                                {image ? (
                                                    <img
                                                        src={image}
                                                        alt={course.courseName}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            display: "block",
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            height: "100%",
                                                            display: "flex",
                                                            justifyContent:
                                                                "center",
                                                            alignItems:
                                                                "center",
                                                            color: "#666666",
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-book"
                                                            style={{
                                                                fontSize:
                                                                    "50px",
                                                            }}
                                                        ></i>
                                                    </div>
                                                )}
                                            </div>

                                            {/* =========================
                                                COURSE CONTENT
                                            ========================== */}
                                            <div
                                                style={{
                                                    padding: "25px",
                                                    background:
                                                        "linear-gradient(180deg, #111111 0%, #080808 100%)",
                                                }}
                                            >
                                                {/* Package */}
                                                <div
                                                    style={{
                                                        display: "inline-block",
                                                        padding:
                                                            "5px 12px",
                                                        borderRadius:
                                                            "20px",
                                                        background:
                                                            "#1f1f1f",
                                                        border:
                                                            "1px solid #3a3a3a",
                                                        color: "#cfcfcf",
                                                        fontSize: "11px",
                                                        fontWeight: "600",
                                                        letterSpacing:
                                                            "1px",
                                                        textTransform:
                                                            "uppercase",
                                                        marginBottom:
                                                            "12px",
                                                    }}
                                                >
                                                    {categories[
                                                        course.packageId
                                                    ] || "Course"}
                                                </div>

                                                {/* Course Name */}
                                                <h3
                                                    style={{
                                                        color: "#ffffff",
                                                        fontSize: "23px",
                                                        fontWeight: "700",
                                                        marginBottom: "12px",
                                                        lineHeight: "1.3",
                                                    }}
                                                >
                                                    {course.courseName}
                                                </h3>

                                                {/* Description */}
                                                <p
                                                    style={{
                                                        color: "#999999",
                                                        fontSize: "14px",
                                                        lineHeight: "1.7",
                                                        minHeight: "72px",
                                                        marginBottom:
                                                            "20px",
                                                    }}
                                                >
                                                    {course.courseDescription}
                                                </p>

                                                {/* Divider */}
                                                <div
                                                    style={{
                                                        height: "1px",
                                                        background:
                                                            "#292929",
                                                        marginBottom:
                                                            "20px",
                                                    }}
                                                ></div>

                                                {/* Price + Button */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        alignItems:
                                                            "center",
                                                        gap: "10px",
                                                    }}
                                                >
                                                    <div>
                                                        <small
                                                            style={{
                                                                display:
                                                                    "block",
                                                                color:
                                                                    "#777777",
                                                                fontSize:
                                                                    "11px",
                                                                marginBottom:
                                                                    "3px",
                                                                textTransform:
                                                                    "uppercase",
                                                                letterSpacing:
                                                                    "1px",
                                                            }}
                                                        >
                                                            Course Price
                                                        </small>

                                                        <span
                                                            style={{
                                                                color:
                                                                    "#ffffff",
                                                                fontSize:
                                                                    "24px",
                                                                fontWeight:
                                                                    "700",
                                                            }}
                                                        >
                                                            ₹
                                                            {
                                                                course.coursePrice
                                                            }
                                                        </span>
                                                    </div>

                                                    <button
                                                        style={{
                                                            border:
                                                                "1px solid #ffffff",
                                                            background:
                                                                "#ffffff",
                                                            color: "#000000",
                                                            padding:
                                                                "10px 18px",
                                                            borderRadius:
                                                                "25px",
                                                            fontSize:
                                                                "13px",
                                                            fontWeight:
                                                                "700",
                                                            cursor:
                                                                "pointer",
                                                        }}
                                                    >
                                                        View Course
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>

            {/* =========================
                PAGE-SPECIFIC RESPONSIVE CSS
            ========================== */}
            <style>
                {`
                    .course-modern-card:hover img {
                        transform: scale(1.03);
                    }

                    .course-modern-card img {
                        transition: transform 0.5s ease;
                    }

                    @media (max-width: 768px) {
                        .courses-page-section {
                            padding: 35px 12px 60px !important;
                        }

                        .courses-page-section h1 {
                            font-size: 30px !important;
                        }

                        .filters-wrapper {
                            gap: 7px !important;
                        }

                        .filters-wrapper button {
                            padding: 9px 14px !important;
                            font-size: 12px !important;
                        }

                        .course-modern-card {
                            border-radius: 12px !important;
                        }

                        .course-modern-card > div:first-child {
                            height: 210px !important;
                        }
                    }
                `}
            </style>
        </>
    );
};

export default Courses;